// AGC: Priority selector — 3 colored buttons (Alta/Media/Baixa)
import React from 'react'
import type { VoiceFieldProps } from './types'

export const PriorityField: React.FC<VoiceFieldProps> = ({
  info,
  inputValues,
  setInputValues,
  lastResponse,
  wizardMode,
}) => {
  // AGC: Color maps for inactive and active states per priority level
  const priColors: Record<string, string> = {
    alta: 'bg-red-500/20 border-red-500/40 text-red-300 hover:bg-red-500/30',
    media: 'bg-yellow-500/20 border-yellow-500/40 text-yellow-300 hover:bg-yellow-500/30',
    baixa: 'bg-green-500/20 border-green-500/40 text-green-300 hover:bg-green-500/30',
  }
  const priActiveColors: Record<string, string> = {
    alta: 'bg-red-500/40 border-red-500/60 text-red-200 font-medium',
    media: 'bg-yellow-500/40 border-yellow-500/60 text-yellow-200 font-medium',
    baixa: 'bg-green-500/40 border-green-500/60 text-green-200 font-medium',
  }

  // AGC: Sizing classes — bigger in wizard mode to fill the full-screen card layout
  const sz = wizardMode
    ? { card: 'p-5', label: 'text-base', btn: 'py-4 text-base', gap: 'gap-2.5' }
    : { card: 'p-2', label: 'text-xs', btn: 'py-1.5 text-xs', gap: 'gap-1' }

  return (
    <div className={`${sz.card} bg-white/5 border border-white/20 rounded-xl`}>
      <div className="mb-3">
        <span className={`text-white/80 ${sz.label} font-medium flex items-center gap-1`}>
          ⚡ {info.fieldLabel}
        </span>
      </div>
      <div className={`flex ${sz.gap}`}>
        {info.suggestions?.map((s: { value: string; label: string }) => {
          const selected = (inputValues.priority || lastResponse?.parsedData?.priority) === s.value
          return (
            <button
              key={s.value}
              onClick={() => setInputValues(prev => ({ ...prev, priority: s.value }))}
              className={`flex-1 px-2 ${sz.btn} rounded border transition-colors ${
                selected
                  ? (priActiveColors[s.value] || 'bg-emerald-500/40')
                  : (priColors[s.value] || 'bg-white/5 border-white/20 text-white/80')
              }`}
            >
              {s.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
